exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".footer-button:hover {\n  box-shadow: 0 13px 8px black, 0 3px 102px black;\n  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/reusableComponents/ChartComponents/footerButton.scss
// module id = 2484
// module chunks = 0